(ns minorodata.connections.sources.forex-rates
  (:require [minorodata.app.utils :as app.utils]))


(def supported-currencies ["AUD" "BGN" "BRL" "CAD" "CHF" "CNY" "CZK" "DKK" "EUR" "GBP" "HKD" "HRK" "HUF" "IDR" "ILS" "INR" "ISK" "JPY" "KRW" "MXN" "MYR" "NOK" "NZD" "PHP" "PLN" "RON" "RUB" "SEK" "SGD" "THB" "TRY" "USD" "ZAR"])


(def source
  {:enabled      true
   :id           "forex-rates"
   :name         "Currency exchange rates"
   :image-source "forex-rates-2.svg"
   :description  "Foreign exchange reference rates published by the European Central Bank"
   :tags         ["admin-finance"]

   :preview-formatter
   (fn []
     (str "Authenticated by API Key for apilayer.com/marketplace/fixer-api"))

   :form
   {:format-for-api
    (fn [data]
      (let [{:keys [name description base-currency api-key]} data]
        {:source-type "forex-rates"
         :name        name
         :description description
         :source      {:base-currency base-currency
                       :api-key       api-key}}))

    :format-for-inputs
    (fn [data]
      (let [{:keys [source name description]} data
            {:keys [base-currency api-key]}   source]
        {:name          name
         :description   description
         :base-currency base-currency
         :api-key       api-key}))

    :validate (constantly nil)

    :id :forex-rates-form

    :blocks [{:block-type :input
              :label      "Source name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}
             {:block-type :input
              :label      "API Key"
              :name       :api-key
              :type       :password
              :required   true
              :value      ""}
             {:block-type :select
              :label      "Base currency"
              :name       :base-currency
              :options    supported-currencies
              :required   true
              :value      "GBP"}
             {:block-type :submit
              :content    "SAVE"}]}


   :extract-form
   {:format-for-api
    (fn [{:keys [name description status currencies action destination-table extract-type
                 backfill-from backfill-to]}]
      {:name          name
       :description   description
       :status        status
       :output-tables [destination-table]

       :config
       {:extracts [{:action            action
                    :report            "eod-rates"
                    :extract-type      extract-type
                    :currencies        currencies
                    :destination-table destination-table
                    :backfill-from     backfill-from
                    :backfill-to       backfill-to}]}})

    :format-for-inputs
    (fn [data]
      (let [{:extract/keys [name description status config]} data

            extract (get-in config [:extracts 0])]
        (merge
         (select-keys extract [:destination-table :report :action :extract-type
                               :currencies :backfill-from :backfill-to])
         (app.utils/keep-non-nil-keys
          {:name          name
           :description   description
           :status        status
           :output-tables []}))))

    :validate (constantly nil)

    :id :forex-rates-extract-form

    :blocks [{:block-type :input
              :label      "Extract name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :select
              :label      "Status"
              :name       :status
              :options    [{:name "Active" :value "active"}
                           {:name "Paused" :value "paused"}]
              :required   true
              :value      "active"}

             {:block-type :subtitle
              :content    "Extract Configuration"}

             {:block-type :select
              :label      "Currencies"
              :name       :currencies
              :options    supported-currencies
              :required   true
              :multiple   true
              :native     false
              :value      []}

             {:block-type :select
              :label      "Extract type"
              :name       :extract-type
              :options    [{:name "Incremental" :value "incremental"}
                           {:name "Full"        :value "historical"}]
              :required   true
              :value      "incremental"}

             {:content "The 'Incremental' extract type will only fetch the most recent exchange rates. Can be scheduled to run every day"
              :conditions [[:eq [:extract-type :value] "incremental"]]}

             {:content "Currency exchange rates are usually updated around 16:00 CET on every business day by the ECB"}

             {:block-type :date-picker
              :label "From"
              :name :backfill-from
              :required false
              :conditions [[:eq [:extract-type :value] "historical"]]}

             {:block-type :date-picker
              :label "To"
              :name :backfill-to
              :required false
              :conditions [[:eq [:extract-type :value] "historical"]]}

             {:block-type :subtitle
              :content    "Data loading options"}

             {:block-type :select
              :label      "Load method"
              :name       :action
              :options    [{:name "Drop, Create, Load" :value "replace"}
                           {:name "Truncate, Load"     :value "reload"}
                           {:name "Append"             :value "append"}]
              :required   true
              :value      "replace"}

             {:content "Drop table, Create table, load entire table (selected columns)"
              :conditions [[:eq [:action :value] "replace"]]}

             {:content "Truncate table, Load entire table (selected columns)"
              :conditions [[:eq [:action :value] "reload"]]}

             {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
              :conditions [[:and [[:action :value] [:extract-type :value]] ["append" "historical"]]]}

             {:content "Find max record in destination table of specified incremental key. Select rows where results of incremental key greater than max record of incremental key in destination table. Insert rows (selected columns) into the destination table no truncation."
              :conditions [[:and [[:action :value] [:extract-type :value]] ["append" "incremental"]]]}

             {:block-type :subtitle
              :content    "Destination table"}

             {:block-type  :warehouse-destination
              :name        :destination-table}

             {:block-type :submit
              :content    "SAVE"}]}})
